import { generators as sharedGenerators, date } from "@/_shared/utils";

const generateSnapshotName = (user = {}) => {
  const { name } = user;
  const salt = sharedGenerators.generateRandomString();
  const [day, time] = date.getIsoString().split(" ");
  const snapshotName = `${salt}_${name}_${day}_${time}.jpg`;
  return snapshotName;
};

export const generators = {
  generateSnapshotName,
};



// WEBPACK FOOTER //
// ./src/authorization/utils/generators.js